/*@ngInject*/
const ExternalUrlController = function ($controller, $scope, coreConstant) {

    angular.extend(this, $controller('baseWidgetController', {$scope: $scope}));

    this.showOverlay = false;

    this.onShowOverlay = function () {
        this.showOverlay = true;
    };

    this.onHideOverlay = function () {
        this.showOverlay = false;
    };

    this.$onInit = function () {
        this.onInit();

        $scope.$on(coreConstant.event.widget.RESIZE_START, this.onShowOverlay.bind(this));
        $scope.$on(coreConstant.event.widget.RESIZE_STOP, this.onHideOverlay.bind(this));

        $scope.$on(coreConstant.event.widget.DRAG_START, this.onShowOverlay.bind(this));
        $scope.$on(coreConstant.event.widget.DRAG_STOP, this.onHideOverlay.bind(this));
    };

};

angular.module('umLanding')
    .controller('externalUrlController', ExternalUrlController);
